<template>
<v-sheet :dark="dark" class="fill-height" color="transparent">
   <v-overlay :value="loading" color="primary" v-if="loading">
        <v-progress-circular indeterminate size="64" @click="loading=false"></v-progress-circular>
      </v-overlay>
  
     <v-dialog
      :dark="dark"
      v-model="showProduct"
     :fullscreen="!largeScreen" scrollable
      hide-overlay
      >
      <product-detail v-model="product" v-if="product"
                    :list="products" :dark="dark"
                    @select="addItem" 
                    @extra="addExtraItem" :fullscreen="!largeScreen" scrollable :max-width="800"
                    @remove="removeCartItem"
                    @update="updateItem"
                    @close="product = null;showProduct = false;"
                    :focus="focusDescription"
                        
                      ></product-detail>
    </v-dialog>
    
 <page-header
      :banner="$vuetify.breakpoint.mobile ? null : host.banner"
      :toolbar-title="title"
      :back="'/'+ host._id"
      :dark="dark"
      :align-end="true"
      :title="title"
      :subtitle="opentext"
    >
     <v-toolbar flat dense slot="extension" v-if="!largeScreen">
         <v-tabs fixed-tabs v-model="tabtype"
    background-color="transparent">
       <v-tab value="deliver" v-if="allowDeliver"><v-icon class="mr-2">delivery_dining</v-icon>{{$t('Common.deliver')}}</v-tab>
       <v-tab value="takeaway"><v-icon class="mr-2">store</v-icon>{{$t('Common.takeaway')}}</v-tab>
       <v-tab value="deliver" v-if="!allowDeliver"  :disabled="!allowDeliver">GEEN BEZORGING</v-tab>
        </v-tabs>
      </v-toolbar>
      <v-toolbar flat dense slot="extension" v-if="largeScreen">
        <v-toolbar-title class="ml-5 primary--text">Afrekenen</v-toolbar-title>
        <v-spacer></v-spacer>
              <div style="width:350px">
      <v-tabs v-model="tabtype"
    background-color="transparent">
       <v-tab value="deliver" v-if="allowDeliver"><v-icon class="mr-2">delivery_dining</v-icon>{{$t('Common.deliver')}}</v-tab>
       <v-tab value="takeaway"><v-icon class="mr-2">store</v-icon>{{$t('Common.takeaway')}}</v-tab>
       <v-tab value="deliver" v-if="!allowDeliver"  :disabled="!allowDeliver">GEEN BEZORGING</v-tab>
        </v-tabs>
        </div>
        </v-toolbar>
    </page-header>
    <!--v-alert :value="modus=='test'" type="warning"  dismissible class="ma-2 main-content mx-auto">
   TESTMODUS: Deze bestelling wordt niet geplaats
    </v-alert-->
<v-container class="main-content mt-5 mb-15 pb-15 mx-auto" :class="{'mt-10': largeScreen}">
   <v-row>
   <v-col :cols="largeScreen ? 8 : 12" class="pl-0 pt-0" :class="{'pa-0': !largeScreen}" >
 <v-card :color="!dark? 'background': null" class="mx-auto" flat :loading="loading" :width="$config.page.width- $config.page.drawerWidth"
 >
 
         
  <v-alert outlined text v-if="!firstDate" type="warning" color="primary" v-html="opentext" class="mx-3"></v-alert>   
<template v-else>
   <v-alert text v-model="showWarning" type="warning" color="primary" dismissible>
   {{warning}}
    </v-alert>
  <v-snackbar
      color="warning"
      v-model="hasMessage"
     top
      dense
      class="mt-15"
    ><div class="d-flex">
    <span v-html="message" class="mt-2"></span>
    <v-spacer></v-spacer>
    <v-btn icon @click="hasMessage=false"><v-icon>close</v-icon></v-btn>
    </div>
    </v-snackbar>
 
        <!--v-text-field
            v-model="user.phone"
            :rules="[$config.rules.required, $config.rules.phone]"
            label="Telefoon"
            prepend-icon="local_phone"
          ></v-text-field-->

  
  <template  v-if="(type=='takeaway' || !allowDeliver) && host._address.name">
      <v-expand-transition>
        <v-list class="py-0" v-if="showHostInfo">
          <v-divider></v-divider>
          <v-list-item
            active-class="primary--text"
          >
              <v-list-item-icon class="mr-2">
                <v-icon
                 
                  color="primary"
                >store</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title v-text="host._address.name"></v-list-item-title>
              </v-list-item-content>
          </v-list-item>
          <v-divider></v-divider>
        </v-list>
        </v-expand-transition>
     </template>
 
 
  <!--v-card-title class="primary--text font-weight-light pt-2" v-if="largeScreen">Afrekenen</v-card-title-->
   <v-list class="py-0" :class="{'card-list': largeScreen}" >
          <v-divider></v-divider>
 
                   <phone-validator ref="phonecheck" v-model="phone" dense icon="phone"
                   @select="selectUser"
                   @reset="selectUser()"
                   @valid="validateUser" :hint="user? null : 'Op welk mobiel nummer kunnen we je bereiken?'"
                   :validate="validatePhone"
                   :force="validatePhone"
                   ></phone-validator>
       <v-divider></v-divider>
          
          <address-block v-if="showSearch"
              allow-delete
              :host="host"
              :popup="true"
              :hide-hubs="true"
              :show="showSearch"
              :amount="cartAmount"
              :base="host._address"
              @select="selectAddress"
              @close="showSearch=false"
            >
            <template v-slot:buttons="{ close }">
              <v-btn text color="grey" depressed @click="deliver=false;showSearch=false">Toch liever afhalen</v-btn>
              <v-spacer></v-spacer>
              <v-btn  color="success" :disabled="address ? false : true" depressed @click="showSearch=false">Selecteren</v-btn>
              </template>
            </address-block>
<template v-if="deliver && allowDeliver">
 
    <template v-if="address && address.zipcode && address.allow">
  
            <v-list-item  
            active-class="primary--text" @click="showSearch=true"
          >
          
               <v-list-item-icon v-if="address.current" class="mr-3">
                  <v-icon>place</v-icon>
              </v-list-item-icon>
              <v-list-item-icon v-else class="mr-3">
                  <v-icon>home</v-icon>
              </v-list-item-icon>
                        <v-list-item-content>
                <v-list-item-title v-text="address.name"></v-list-item-title>
              </v-list-item-content>
              <v-list-item-action v-if="!address.number || address.number==''" @click.stop>
                  <v-text-field :value="address.number" color="red" @change="setAddressNumber" hide-details style="width:120px;" :error="address.number ? false : true" label="Huisnummer"
                  append-outer-icon="check"></v-text-field>
                </v-list-item-action>
             <v-list-item-icon>
                <v-icon>arrow_drop_down</v-icon>
              </v-list-item-icon>
          </v-list-item>
            <v-divider
          ></v-divider>
    </template>
     <template v-else>
       <v-list-item  
            active-class="primary--text" @click="showSearch=true"
          >
          
               <v-list-item-icon class="mr-3">
                  <v-icon :color="user? 'error' : null">place</v-icon>
              </v-list-item-icon>
                        <v-list-item-content>
                <v-list-item-title :class="{'font-weight-bold error--text' : user ? true: false}">Selecteer je adres...</v-list-item-title>
                <v-list-item-subtitle>Laat ons weten waar we kunnen bezorgen of kies voor afhalen</v-list-item-subtitle>
              </v-list-item-content>
             <v-list-item-icon>
                <v-icon>arrow_drop_down</v-icon>
              </v-list-item-icon>
          </v-list-item>
            <v-divider
          ></v-divider>
          
    
    <!--v-btn text color="primary" class="ml-10" v-if="!showSearch" @click="showSearch=true">Adres kiezen</v-btn-->
    
     </template>


       
        </template>
 </v-list>
    <v-card-title class="primary--text font-weight-light pl-5" v-if="type=='reservation'">Reserveren bij</v-card-title>
  
    <template  v-if="type=='deliver'">
    <v-card-title class="primary--text font-weight-light pl-5">Bezorgtijd</v-card-title>
    <!--v-card-text>De minimale bezorgtijd inclusief bereiding is <b>{{host.delivery.wait}} minuten</b>. Geef aan wanneer je je maaltijd wilt laten bezorgen.
    </v-card-text-->
    </template>
     <template  v-if="type=='takeaway'">
    <v-card-title class="primary--text font-weight-light pl-5">Afhaaltijd</v-card-title>
    <!--v-card-text>De minimale bereidingstijd bij {{host.name}} is <b>{{host.order.wait}}</b> minuten. Geef aan wanneer je je maaltijd wilt ophalen.
    </v-card-text-->
     </template>
 
 <v-list class="py-0" :class="{'card-list': largeScreen}" >
    <v-divider></v-divider>
 <v-list-item 
          @click="sheet = true"
        >
          <v-list-item-icon class="mr-3">
            <v-icon color="primary">mdi-calendar-clock</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="mb-2 mt-1 primary--text" v-if="!due">Selecteer</v-list-item-title>
            <v-list-item-title class="mb-2 mt-1 primary--text" v-else-if="asap">{{ due | moment('HH:mm') }} - Zo snel mogelijk</v-list-item-title>
            <v-list-item-title class="mb-2 mt-1 primary--text" v-else>{{ due | moment('HH:mm') }}</v-list-item-title>
            <v-list-item-subtitle v-if="type=='deliver'">Geef aan wanneer je je maaltijd wilt laten bezorgen. Minimaal: <b>{{host.delivery.wait}} minuten</b>. </v-list-item-subtitle>
            <v-list-item-subtitle  v-else>Geef aan wanneer je je maaltijd wilt ophalen. Minimaal: <b>{{host.order.wait}}</b> minuten.</v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-icon>
            <v-icon>arrow_drop_down</v-icon>
          </v-list-item-icon>
          
        </v-list-item>
        <v-divider></v-divider>
  </v-list>
  <v-dialog v-model="sheet" scrollable v-if="largeScreen">
    <time-selector :value="$moment(due)" :asap="asap" :first-date="firstDate" :list="hourList" @close="sheet=false" @select="select"></time-selector>
    </v-dialog>
 <v-bottom-sheet v-model="sheet" scrollable v-else>
    <time-selector :value="$moment(due)" :asap="asap" :first-date="firstDate" :list="hourList" @close="sheet=false" @select="select"></time-selector>
    </v-bottom-sheet>
         <template>   
  <v-toolbar id="#donation" ref="donation" class="mt-5 px-0" dense flat color="transparent">
    <v-card-title class="px-0 d-inline-block text-truncate primary--text font-weight-light">Steun je lokale verenigingen met</v-card-title>
    <v-spacer></v-spacer>
    <v-btn color="primary" icon @click="clubInfo=!clubInfo"><v-icon>info</v-icon></v-btn>
  </v-toolbar>


    <v-card flat outlined>
      
      <v-expand-transition>
          <v-card-text v-if="clubInfo" class="mt-2">
            Ook het verenigingsleven heeft een zware periode achter de rug. Als veel mensen een kleine bijdrage doen, maakt dit een groot verschil. Eetplein zorgt voor een eerlijke verdeling of kies zelf een vereniging.
          </v-card-text>
          </v-expand-transition>
      <v-chip-group group tile column active-class="primary" 
      v-model="donationAmount" class="pa-3 mx-auto pb-0">
      <template v-for="(donation,i) in  donations">
      <v-chip label :outlined="donationAmount!==donation.amount && (!donation.custom || donations.filter(d=>d.amount==donationAmount).length>0 || donationAmount==null)"
              class="text-center mx-0 mr-1 flex-grow-1 justify-center" color="primary" style="min-width:75px;"
              :dark="donationAmount==donation.amount || (donation.custom && donations.filter(d=>d.amount==donationAmount).length==0)"
              :key="'donation' + i"
              :value="donation.amount"
            v-text="donation.name"
            @click="showDonationAmount = donation.custom ? true : false;editDonation=donation.custom"
            >        
            </v-chip>
      </template>
            
            </v-chip-group>
  <v-card-actions class="pl-3 pt-5 mb-2">
              <v-select
                v-model="club"
              hide-details
                :items="clublist"
            item-text="name"
            item-value="club._id"
            label="Doel" 
            :no-data-text="`Alle verenigingen in ${clubName}`"
            class="primary--text pa-0 ma-0"
            color="primary"
            return-object
          
          >
          <template v-slot:item="{ index, item }">
          <v-list-item
            ripple class="ma-0 pa-0"
          >
            <v-list-item-avatar v-if="item.logo">
            <v-img :src="item.logo"></v-img>
            </v-list-item-avatar>
            <v-list-item-icon v-else>
              <v-icon  class="ml-1">hub</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>
                {{item.name}}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-divider class="mt-2"></v-divider>
        </template>
          </v-select>
          <v-spacer></v-spacer>
          <template v-if="showDonationAmount">
          <v-text-field v-model.number="donationAmount" 
                prefix="€" autofocus @focus="$event.target.select()" style="max-width:125px"
                hide-details flat type="number" class="ml-3 pa-0 ma-0 float-right" dense @keypress="checkPoint"
                append-outer-icon="check" @click:append-outer="editDonation=donationAmount==0"></v-text-field>
              </template>
                <span class="primary--text mr-2" v-else @click="showDonationAmount=!showDonationAmount">{{donationAmount | toCurrency}}</span>
  </v-card-actions>
          
  </v-card>
  </template>
    <v-card-title class="primary--text font-weight-light pl-5">Betaling</v-card-title>
   <v-list class="py-0" :class="{'card-list': largeScreen}" >
      <v-list-item-group
        v-model="paymenttype"
        mandatory
      >
        <template v-for="(item, i) in payments">
          <v-divider
               :key="`divider-${i}`"
          ></v-divider>

          <v-list-item
            :key="`item-${i}`"
            :value="item.value"
           
          >
            <template v-slot:default="{ active }">
              <v-list-item-action class="mr-4">
                <v-checkbox off-icon="$radioOff" on-icon="$radioOn"
                  :input-value="active"
                  
                ></v-checkbox>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title v-text="item.text"></v-list-item-title>
                <v-list-item-subtitle v-if="item.description" v-text="item.description"></v-list-item-subtitle>
              </v-list-item-content>
              <!--v-list-item-action v-if="item.price">
                {{item.price | toCurrency}}
              </v-list-item-action-->
            </template>
          </v-list-item>
        </template>
      </v-list-item-group>
      <v-divider
          ></v-divider>
     </v-list>
   <v-list class="py-0 my-5" :class="{'card-list': largeScreen}">
      <v-divider
          ></v-divider>
      <v-textarea class="pl-3"
                                                        v-model="description"
                                                        background-color="transparent"
                                                        flat
                                                        hide-details
                                                        placeholder="Opmerking"
                                                        :rows="3" full-width 
                                                        auto-grow
                                                        >
                                                    </v-textarea>
                                                    <v-divider></v-divider>
                                              
    </v-list>
  </template>
  
  </v-card>
</v-col>
      <v-col :cols="largeScreen ? 4 : 12" class="pa-0">

        
   <cart 
        :value="true" 
        :inline="true"
        @close="showCart = false"
        @edit="editItem" 
        :donationAmount="donationAmount"
        :allow-deliver="allowDeliver"
        :allow-checkout="!deliver || (allowDeliver && address && cartAmount>address.min)"
        :checkout="true"
        @comment="commentItem"
         @update="updateItem"
      >
      <template v-if="donationAmount>0" slot="extraitems">
<v-list-item @click="$vuetify.goTo($refs.donation, {
          duration: 500,
          offset: 120,
        })">
    <v-list-item-content>
      <v-list-item-title v-if="club">{{club.name}}</v-list-item-title>
      <v-list-item-subtitle v-else>{{hubClub.name}}</v-list-item-subtitle>
    </v-list-item-content>
    <v-list-item-action class="text-right">
      {{donationAmount | toCurrency}}
    </v-list-item-action>
</v-list-item>
<v-divider></v-divider>
</template>
      
      <template v-if="getStamps >= stampmax" slot="extraitems">
  <v-list-item>
    <v-list-item-content>
      <v-list-item-title>## Volle kaart ##</v-list-item-title>
      <v-list-item-subtitle>Gratis snack of drankje</v-list-item-subtitle>
    </v-list-item-content>
    <v-list-item-action> gratis </v-list-item-action>
  </v-list-item>
  <v-divider></v-divider>
</template>
     <template slot="extrainfo">
        <v-list-item>
          <v-list-item-title class="primary--text" v-if="code">
            CODE: <b>{{code}}</b>
          </v-list-item-title>  
            <template v-else-if="getStamps >= stampmax"></template>

          <v-list-item-title class="grey--text" v-else-if="getStamps==1">
            {{getStamps}} stempel
          </v-list-item-title>
          <v-list-item-title class="grey--text" v-else-if="getStamps>1">
            {{getStamps}} stempels
          </v-list-item-title>
        </v-list-item>
          
             <v-card-title v-if="deliver && address && cartAmount<address.min" class="error--text justify-center">
            Minimmaal bestelbedrag: {{address.min | toCurrency}}</v-card-title>
            <v-card-subtitle v-else-if="address && deliver && cartAmount<address.max" class="text-center">Gratis bezorgen vanaf {{address.max | toCurrency}}</v-card-subtitle>
  
            </template>
  	  	
        <v-btn slot="buttons" block depressed v-if="largeScreen" :color="buttonColor" :disabled="buttonDisabled" large class="flex-grow-1 mt-3" @click.stop="orderThis"><v-icon class="mr-2" v-text="buttonIcon"></v-icon> {{modus=='test' ? 'TEST ' : ''}}{{$t('Common.orderthis')}} ({{checkOutAmount | toCurrency}})<v-icon class="ml-2" v-if="!buttonDisabled">navigate_next</v-icon></v-btn>

      </cart>
      </v-col>
      </v-row>
  </v-container>
          <v-footer flat v-if="!largeScreen" fixed class="justify-center main-content red" color="red" :height="platform=='ios' ? 90 : null" style="">
          <v-btn block depressed :class="{'mb-5': platform=='ios'}" :color="buttonColor" :disabled="buttonDisabled" large class="flex-grow-1" @click.stop="orderThis"><v-icon class="mr-2" v-text="buttonIcon"></v-icon> {{modus=='test' ? 'TEST ' : ''}} {{$t('Common.orderthis')}} ({{checkOutAmount | toCurrency}})<v-icon class="ml-2" v-if="!buttonDisabled">navigate_next</v-icon></v-btn>
  </v-footer>
  
  </v-sheet>
</template>

<script>
import { Capacitor } from "@capacitor/core";
import { Browser } from "@capacitor/browser";
import { mapActions, mapGetters } from "vuex";
import tt from "@/modules/timeTable";
import ProductDetail from "../components/ProductDetail.vue";
import PageHeader from "../components/PageHeader.vue";
import headerItem from "@/modules/headerItem";
import CartFooter from "../components/CartFooter.vue";
import AddressBlock from "../components/AddressBlock.vue";
import locationService from "@/modules/locationService";
import Cart from "../components/Cart.vue";
import phoneValidator from "../components/phoneValidator.vue";
import productItem from "@/modules/productItem";
import TimeSelector from "@/components/TimeSelector.vue";
import externalLink from '@/components/externalLink'
import timeTable from "@/components/feature/timeTable.vue";
import FeatureCard from '../components/feature/featureCard.vue';

export default {
  mixins: [tt, locationService, productItem, headerItem],
  components: {
    PageHeader,
    CartFooter,
    Cart,
    AddressBlock,
    phoneValidator,
    TimeSelector,
    externalLink,
    timeTable,
    FeatureCard,
    ProductDetail
  },
  data() {
    return {
      editDonation: true,
      showHostInfo: false,
      loading: false,
      window: 0,
      addressList: null,
      editAdress: false,
      newAddress: null,
      showCart: false,
      validatePhone: false,
      due: null,
      asap: true,
      message: null,
      warning: null,
      sheet: false,
      descriptionsss: null,
      showSearch: false,
      order: null,
      selectedClub: null,
      donationAmount: null,
      clubInfo: false,
      showDonationAmount: false,
      validated: false,
      paymenttype: "ideal",
      showProduct:false,
      focusDescription: false,
    };
  },
  computed: {
    ...mapGetters([
      "now",
      "hub",
      "getPhone",
      "modus",
      "cart",
      "clubs",
      "host",
      "takeawayAmount",
      "deliverAmount",
      "user",
      "orders",
      "products",
      "credits",
      "totalAmount",
      "cartAmount",
      "code",
      "discountAmount",
      "deliveryAmount",
      "discountNames",
    ]),
    phone: {
      get() {
        return this.getPhone;
      },
      set(value) {
        this.setPhone(value);
      },
    },
    buttonDisabled() {
      if (this.loading) return true;
      if (!this.allowOrderThis) return true;
      //if (!this.validated && this.paymenttype != "ideal") return false;
      return false;
    },
    buttonColor() {
      if (this.loading || this.modus == "test") return "warning";
      //if (!this.allowOrderThis) return "warning";
      //if (!this.validated && this.paymenttype != "ideal") return "warning";
      return "success";
    },
    buttonIcon() {
      if (this.loading) return "pending";
      if (!this.allowOrderThis) return "close";
      if (!this.validated && this.paymenttype != "ideal")
        return "published_with_changes";
      return "check";
    },
    showWarning: {
      get() {
        return this.warning ? true : false;
      },
      set(value) {
        this.warning = null;
      },
    },
    paymentProvider(){
      if (this.host.order && this.host.order.provider) return this.host.order.provider
      return 'mollie'
    },
    payment() {
      return { 
              type: this.paymenttype, 
              paid: false, 
              status: "open",
              provider: this.payments.filter(p=>p.value==this.paymenttype)[0].provider
              };
    },
    transactionAmount() {
      let payment =
        this.$config.payment.filter((p) => p.value == this.paymenttype)[0] ||
        {};
      return payment.price || 0;
    },
    stampmax() {
      if (this.host.order && this.host.order.stampmax > 0)
        return this.host.order.stampmax;
      return this.$config.stamps.max;
    },
    stampvalue() {
      if (this.host.order && this.host.order.stampvalue)
        return this.host.order.stampvalue;
      return this.$config.stamps.value;
    },
    getStamps() {
      if (this.credits > 0) return this.credits;
      let stamps = 1
      if (this.stampvalue > 0)
        stamps =  Math.round(this.checkOutAmount / this.stampvalue);
        if (stamps == 0) return 1
      return stamps;
    },
    clubName(){
      if (this.host._hub) return this.host._hub.name
      return (this.host._address ? this.host._address.city : '')
    },
    donations() {
      let amount = this.totalAmount + this.transactionAmount;
      let round = Math.round((Math.ceil(amount) - amount) * 100) / 100;
      let e = [
        { name: "1 euro", amount: 1 },
        { name: "2 euro", amount: 2 },
        { name: "Anders", amount: 0, custom: true },
      ];

      if (round > 0) {
        e = e.filter((a) => a.amount != round);
        e.push({ name: "Afronden", amount: round, align: true });
        //this.donationAmount = round
      } else {
        e.unshift({ name: "50 cent", amount: 0.5 });
      }
      return e;
    },
    address: {
      get() {
        return this.$store.state.config.address;
      },
      set(value) {
        this.setConfig({ address: value });
      },
    },
    hasMessage: {
      get() {
        return this.message ? true : false;
      },
      set(value) {
        this.message = null;
      },
    },
    deliver: {
      get() {
        return this.type == "deliver";
      },
      set(value) {
        this.setConfig({ type: value == true ? "deliver" : "takeaway" });
      },
    },
    title() {
      return this.host.name || this.$t("Common.checkout");
    },
    dark() {
      return this.$store.state.config.dark;
    },
    hubClub() {
      if (!this.host._hub) return {
         _id: this.host._id,
          name: "Verenigingsleven " + (this.host._address ? this.host._address.city : ''),
      }
      return {
        _id: this.host._hub._id,
        name: "Verenigingsleven " + this.host._hub.name,
      };
    },
    club: {
      get() {
        try {
          if (!this.selectedClub)
            this.selectedClub =
              this.clublist.filter((host) => host._favorite)[0] || this.hubClub;
        } catch (e) {
          return this.hubClub;
        }
        return this.selectedClub;
      },
      set(value) {
        this.selectedClub = value;
      },
    },
    clublist() {
      let c = [];
      if (this.clubs && this.clubs.filter)
        this.clubs
          .filter((c) => c._hub == this.host._hub._id)
          .map((host) => c.push(host));
      c.push(this.hubClub);
      return c;
    },
    payments() {
      //this.host.order.ideal_force = false;
      let arr = this.$config.payment.filter(
        (p) =>
          (!this.host.order.nopin || p.value !== "pin") && // || !this.deliver
          (this.host.order.ideal || p.value !== "ideal") &&
          (!this.host.order.ideal_takeaway || p.value !== "cash" || this.deliver) && 
          (!this.host.order.ideal_first ||
            p.value == "ideal" ||
            this.orders.length > 0) &&
          (!this.host.order.ideal_force || p.value == "ideal")
      );
      arr = arr.filter(p=>p.value != 'ideal' || p.provider == this.paymentProvider)
      if (!this.validated)
        arr.map(
          (p) =>
            (p.description =
              p.value == "ideal" ? p.description : "Telefoonnummer controle")
        );
      return arr;
    },
    tabtype: {
      get() {
        if (!this.allowDeliver) return 0;
        return this.$store.state.config.type == "deliver" ? 0 : 1;
      },
      set(value) {
        if (!this.allowDeliver) return this.setConfig({ type: "takeaway" });
        this.setConfig({ type: value == 0 ? "deliver" : "takeaway" });
      },
    },
    type: {
      get() {
        return this.$store.state.config.type;
      },
      set(value) {
        this.setConfig({ type: value });
      },
    },
    allowDeliver() {
      
      let allowDeliver = this.host.delivery && this.host.delivery.deliver ? true : false;
      if (!allowDeliver) this.deliver=false 
      return allowDeliver
    },
    deliverNotification() {
      if (
        this.address &&
        this.type == "deliver" &&
        this.cartAmount < this.address.min
      )
        this.warning =
          "Minimale bestelbedrag voor bezorging is " +
          this.$options.filters.toCurrency(this.address.min);
      return this.warning ? true : false;
    },
    allowOrderThis() {
      //if (this.loading) ret
      if (!this.firstDate) return false;
      if (!this.due) this.due = this.firstDate
      if (!this.user) return false
      if (this.type == "deliver") {
        if (!this.address) return false
        if (this.address && this.address.allow !== true) return false;
        if (this.address && !this.address.zipcode) return false;
        if (this.address && !this.address.number) return false;
        if (
          this.address &&
          this.type == "deliver" &&
          this.cartAmount < this.address.min
        )
          return false;
      }
      return true
    },
    hourList() {
      let arr = this.getFullTimeTable();
      return arr; //.filter(t=>t.h >= this.startHour)
    },
    lastOrder() {
      return this.orders.filter(
        (o) => o._host._id == this.host._id && o.payment
      )[0];
    },
    checkOutAmount() {
      return (
        this.totalAmount +
        this.deliveryAmount +
        (this.donationAmount || 0) +
        this.transactionAmount
      );
    },
    pageHeight() {
      return document.body.scrollHeight;
    },
  },
  mounted() {
    try {
      if (this.$store.state.config.description)
        this.description = this.$store.state.config.description;
      this.validated = this.user._verified ? true : false;
      this.setTimeTable(this.host);
      this.due = this.firstDate.toDate();
      this.loadOrder();
    } catch (e) {}
  },
  watch: {
    tabtype(value) {
      this.$vuetify.goTo(0);
    },
    now(value) {
      if (this.asap) return (this.due = this.firstDate.toDate());
      if (this.$moment(this.firstDate).isAfter(this.$moment(this.due)))
        this.due = this.firstDate.toDate();
    },
    deliver(value) {
      if (this.asap) this.due = this.firstDate;
      if (this.$moment(this.firstDate).isAfter(this.$moment(this.due)))
        this.due = this.firstDate.toDate();
      this.updateCart();
    },
    address(value) {
      if (value) this.showSearch = false;
    },
    paymenttype(value) {
      this.setConfig({ paymenttype: value });
      //this.validatePhone = value !=='ideal'
    },
  },
  methods: {
    ...mapActions([
      "login",
      "setTimer",
      "setPhone",
      "setConfig",
      "addCartItem",
      "removeCartItem",
      "setUser",
      "updateCart",
      "addToCart",
      "setCartItem",
      "resetCart",
      "setCode"
    ]),

    loadOrder() {
      this.paymenttype = this.$store.state.config.paymenttype;
      if (this.lastOrder) {
        //this.type = this.lastOrder.deliver ? 'deliver' : 'takeaway'
        this.paymenttype = this.lastOrder.payment.type;
      }
      this.addressList = [];
      //if (this.user._address) this.user._address.map(address=>this.addAddress(address))
      //if (this.$store.state.config.address) this.addAddress(this.$store.state.config.address)
      if (this.address && !this.address.allow) this.address = null;
    },
    selectAddress(address) {
      this.address = address
      this.showSearch = false;
    },
    checkPoint(event) {
      if (event.charCode == 46) {
        //190
        event.preventDefault();
        return false;
      }
    },
    deleteAddress(address) {
      this.addressList = this.addressList.filter(
        (a) => a.name !== address.name
      );
      this.address = this.addressList[0];
      this.newAddress = null;
    },
    setAddressNumber(number){
      if (!this.address) return null
      this.address.number = number
      this.address.name = [this.address.street,this.address.number ,this.address.addition,",",this.address.city].filter(a=>a!=undefined).join(' ').replace(' , ',', ')
    },
    addItem(product){
      return this.addToCart(product, true);
    },
    updateItem(product){
        return this.setCartItem(product)
    },
    addExtraItem(product){
      this.addToCart(product, true);
    },
    editItem(product) {
      this.product = product;
      this.snackbar = false;
      this.focusDescription = false
      this.showProduct = true;
    },
    commentItem(product){
      this.focusDescription = true
      this.product = product;
      this.snackbar = false;
      this.showProduct = true;
    },
    selectUser(user){
        this.validated = (user && user._verified) ? true : false;
        this.validatePhone = false
        this.phone = user ? user.phone : null
        this.setUser(user)
        console.log(this.allowOrderThis)
    },
    async validateUser(user) {
      this.validated = user._verified ? true : false;
      if (this.code) {
        await this.$http.post("/api/host/code/" + this.code, {index: user._id , source: 'stamp'});
        let response = await this.$http.post("/api/host/info", {
            index: this.host._id });
        if (response.data._stamps) this.host._stamps = response.data._stamps
      }
      if (user) this.phone = user.phone
      return user;
    },
    async registerUser() {
      if (!this.phone || this.loading || this.phone.length !== 10) return false;
      this.loading = true;
      try {
        let response = await this.$http.post("/api/auth/signup", {
          phone: this.phone,
        });
        this.loading = false;
        if (response.data.error)
          return (this.message =
            "Er is iets misgegaan bij het aanmelden, probeer het opnieuw." +
            response.data.error.message);
        if (response.data.status == "OK" && response.data.user) {
          this.login(response.data);
          return this.$nextTick(() => this.orderThis());
        }
        if (response.data.status == "OK")
          this.$router.push({
            path: "/login",
            query: { redir: "./checkout" },
          });
      } catch (e) {
        this.message1 =
          "Er is iets misgegaan bij het aanmelden, probeer het opnieuw. " +
          e.message;
      }
      this.loading = false;
    },
    async orderThis() {
      if (!this.user) { //&& (!this.phone || this.phone.length != 10)
        this.$vuetify.goTo(this.$refs.phonecheck, {
          duration: 500,
          offset: 120,
        });
        return this.$refs.phonecheck.focus();
      }
      //if (!this.user && this.phone) return await this.registerUser();
      if (!this.user) return false;
      //this.validatePhone = false
      if (!this.validated && this.paymenttype != "ideal"){
        this.validatePhone = true
        return this.$nextTick(()=> {
          this.$refs.phonecheck.getCode()
        })
      }
      if (!this.allowOrderThis) return false
      this.payment.type = this.paymenttype;
      let order;
      try {
        this.loading = true;
        let host = this.host;
        let customer = this.user;
        let due = this.due;
        if (this.asap) due = this.firstDate.toDate();
        console.log(this.host._stamps, this.getStamps,this.stampmax)
        let stamps = (this.host._stamps + this.getStamps > this.stampmax && this.stampmax)
              ? -this.stampmax
              : this.getStamps
        if (stamps == 0) stamps = 1
        order = Object.assign(this.order || {}, {
          date: new Date(),
          due: due,
          amount: this.checkOutAmount,
          transaction: this.transactionAmount,
          discount: this.discountAmount,
          donation_amount: this.donationAmount,
          donation: this.club ? this.club.name : null,
          deliver_amount: this.deliveryAmount,
          source: "app",
          api: true,
          platform: this.platform,
          deliver: this.type == "deliver",
          payment: this.payment,
          asap: this.asap,
          name: host.name,
          status: "order",
          description: this.description,
          first: this.orders.length == 0,
          engagement: {},
          stamps: stamps, // collect stampcard,
          collected: stamps < 0,
        });
        order["|ORDERITEMS"] = this.cart.map((c, ii) => {
          return Object.assign(
            { _id: c._id, _multiple: ii + 1, $amount: c.$quantity * c.price },
            getProps(c)
          );
        });
        order["|OWNERS"] = [{ _id: customer._id }];
        order["#ORDERS"] = [{ _id: host._id }]; //, '|CONSUMERS' : {_id: customer._id}
        if (order.deliver && this.address) {
          this.address.$amount = this.address.$amount || this.address.price;
          order["|ADDRESS"] = [this.address];
        }
        let puburl =
          this.modus == "test"
            ? this.$config.public_test_url
            : this.$config.public_url;
        let redir = document.location.origin || puburl;
        let thanks = Capacitor.isNativePlatform()
          ? puburl + "thanks/" + host._id.split("/")[1]
          : null;
        // return console.log(order,redir,thanks)
        let response = await this.$http.post("/api/order/add/" + customer._id, {
          order: order,
          redir,
          thanks,
        });
        order = response.data;
        //return console.log(order)
        this.order = order;
        //add Donations
        if (this.club) {
          await this.$http.post("/api/edge/DONATIONS/" + this.club._id, {
            _id: this.order._id,
            date: new Date(),
            amount: this.donationAmount,
          });
          //ADDING FAVORITE
          await this.$http.post("/api/edge/CONSUMERS/" + this.club._id, {
            _id: this.user._id,
            date: new Date(),
          });
        }
        //ADDING FAVORITE
        await this.$http.post("/api/edge/CONSUMERS/" + host._id, {
          _id: this.user._id,
          date: new Date(),
        });
        //ADDING ADDRESS
        if (this.deliver && order._address && order._address._id)
          await this.$http.post("/api/edge/ADDRESS/" + this.user._id, {
            _id: order._address._id,
            date: new Date(),
          });
        //ADDING STAMP
        await this.$http.post("/api/edge/STAMPS/" + this.user._id, {
          _id: order._id,
          date: new Date(),
          amount: order.amount,
          count: this.host._stamps == this.stampmax ? -this.stampmax + 1 : 1,
        });
        response = await this.$http.get("/api/auth/me");
        if (response.data.user) this.setUser(response.data.user);
        //if (order.payment.url) return this.gotoPayment(order)
        this.resetCart()
        // if (order.payment.type=='ideal') return this.message = "Er is iets misgegaan bij de iDEAL betaling, probeer het opnieuw"
        this.loading = false;
        if (!order._id)
          return (this.message =
            "Er is iets misgegaan bij je bestelling. Controleer uw gegevens en probeer het nogmaals.");

        this.$router.push({
          path: "/" + order._id,
          query: { type: "checkout" },
        });
      } catch (e) {
        ///MAIN ERROR
        console.log(e.message);
        this.message = e.message;
        if (!order || !order._id)
          this.message =
            "Er is iets misgegaan bij je bestelling. Controleer uw gegevens en probeer het nogmaals.";
        if (order && order._id)
          this.message =
            "Bedankt voor je bestelling, Er is iets misgegaan bij de berichtgeving. Controleer je bestelling op je dashboard.";

        this.loading = false;
      }
    },
    async gotoPayment(order) {
      //document.location.href.replace('checkout','orders')
      if (Capacitor.isNativePlatform()) {
        Browser.addListener("browserFinished", (info) => {
          this.loading = false;
          this.$router.push({ path: "/" + order._id });
        });
        let w = await Browser.open({ url: order.payment.url });
      } else {
        return (document.location = order.payment.url);
      }
    },
    select({ date, asap }) {
      this.due = date || this.firstDate.toDate();
      this.asap = asap;
      this.sheet = false;
    },
  },
};
function getProps(doc, c) {
  if (!c) c = "$";
  let props = {};
  for (var prop in doc) {
    var chr = prop.substr(0, 1);
    if (chr == c) {
      if (Array.isArray(doc[prop])) {
        props[prop] = doc[prop].map((p) => simpleStringify(p));
      } else {
        props[prop] = doc[prop];
      }
    }
  }
  return props;
}
function simpleStringify(object) {
  var simpleObject = {};
  for (var prop in object) {
    if (!object.hasOwnProperty(prop)) {
      continue;
    }
    if (typeof object[prop] == "object") {
      continue;
    }
    if (typeof object[prop] == "function") {
      continue;
    }
    simpleObject[prop] = object[prop];
  }
  return JSON.parse(JSON.stringify(simpleObject)); // returns cleaned up JSON
}
</script>
<style>
.v-text-field > .v-input__control > .v-input__slot:before {
  border: 0;
}
.col-divider {
  border-left: 2px solid #d1d1d1;
}
</style>

